import { combineReducers } from 'redux';

import filtersReducer from './filters';
import coverageReducer from './coverage/reducers';
import testHistoryReducer from './test-history/reducers';
import testOverviewReducer from './test-overview/reducers';
import testErrorReducer from './test-error/reducers';
import trendsReducer from './trends/reducers';

const reducers = {
  filters: filtersReducer,
  coverage: coverageReducer,
  testHistory: testHistoryReducer,
  testOverview: testOverviewReducer,
  testError: testErrorReducer,
  trends: trendsReducer,
};

export default combineReducers(reducers);
